import React from 'react';
import type { InsyncModelWidgetConfig } from './types';

interface Props {
  config: InsyncModelWidgetConfig;
  onChange?: (config: InsyncModelWidgetConfig) => void;
}

const InsyncModelWidgetBuilder: React.FC<Props> = () => (
  <div className="p-4 text-sm text-neutral-500">
    The InSync model renders automatically for the assigned asset — no configuration needed.
  </div>
);

export default InsyncModelWidgetBuilder;
